import * as caseTypes from './casesTypes';

const initialState = {
  dateFrom_input: undefined,
  dateTo_input: undefined,
  clientIndex: undefined,
  clientId: undefined,
  pathwayIndex: undefined,
  pathwayId: undefined,
  entityIndex: undefined,
  entityId: undefined,
  daysOldIndex: undefined,
  daysOldId: undefined,
  casePhaseIndex: undefined,
  casePhaseId: undefined,
  countryId: undefined,
  countryIndex: undefined,
  yearId: undefined,
  yearIndex: undefined,
  caseContactEmailAddress: undefined,
  filter: undefined,
  eyStatusId: undefined,
  eyStatusIndex: undefined,
  internalSLAId: undefined,
  internalSLAIndex: undefined,
  externalSLAId: undefined,
  externalSLAIndex: undefined,
  onHoldId: undefined,
  onHoldIndex: undefined,
  flagsId: undefined,
  flagsIndex: undefined,
  caseClientName: undefined,
  serviceTypeId: undefined,
  serviceTypeIndex: undefined,
  experianValidatedId: undefined,
  experianValidatedIndex: undefined,
  // eyStatusId: undefined,
  // eyStatusIndex: undefined,
};

const casesFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case caseTypes.CLEAR_FILTER:
      return { ...state, ...initialState, caseContactEmailAddress: '', caseClientName: '' };

    case caseTypes.ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };

    case caseTypes.ON_CHANGE_DATE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export { initialState };
export default casesFilterReducer;



// WEBPACK FOOTER //
// ./src/ui/features/Cases/state/casesFilterReducer.js